// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-menu-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 24px;
  width: 100%;
}

.menu-card {
  border-radius: 15px;
  height: 100%;
  background: #fff;
  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease;
}

.menu-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1) !important;
}

.menu-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.menu-image-wrapper {
  height: 160px;
  overflow: hidden;
  position: relative;
}

.img-menu {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.menu-card:hover .img-menu {
  transform: scale(1.1);
}

.category-tag {
  position: absolute;
  top: 10px;
  left: 10px;
  color: white;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 10px;
  font-weight: bold;
  backdrop-filter: blur(4px);
}

/* Category Colors */
.category-daging {
  background: rgba(139, 0, 0, 0.85);
}

.category-fast-food {
  background: rgba(255, 193, 7, 0.9);
  color: #212529;
}

.category-sayur-sayuran {
  background: rgba(25, 135, 84, 0.85);
}
`, "",{"version":3,"sources":["webpack://./src/styles/menu.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB;;wBAEsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC","sourcesContent":[".card-menu-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 24px;\n  width: 100%;\n}\n\n.menu-card {\n  border-radius: 15px;\n  height: 100%;\n  background: #fff;\n  transition:\n    transform 0.3s ease,\n    box-shadow 0.3s ease;\n}\n\n.menu-card:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1) !important;\n}\n\n.menu-card:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);\n}\n\n.menu-image-wrapper {\n  height: 160px;\n  overflow: hidden;\n  position: relative;\n}\n\n.img-menu {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.5s ease;\n}\n\n.menu-card:hover .img-menu {\n  transform: scale(1.1);\n}\n\n.category-tag {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  color: white;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 10px;\n  font-weight: bold;\n  backdrop-filter: blur(4px);\n}\n\n/* Category Colors */\n.category-daging {\n  background: rgba(139, 0, 0, 0.85);\n}\n\n.category-fast-food {\n  background: rgba(255, 193, 7, 0.9);\n  color: #212529;\n}\n\n.category-sayur-sayuran {\n  background: rgba(25, 135, 84, 0.85);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
